import React from 'react'
import * as Yup from 'yup'
import { Field, FieldConfig, FieldProps } from 'formik'
import { FileUploaderBase as FileUploader, createFileUploaderValidation } from '@carsys/ui'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface Props
  extends Pick<FieldConfig<File[]>, 'name'>,
    Partial<Pick<React.ComponentProps<typeof FileUploader>, 'PaperComponent' | 'multiple' | 'accept' | 'maximumFilesize'>> {}

export const FileUploaderFormik = ({
  name,
  multiple = false,
  accept = ['jpg', 'jpeg', 'png', 'svg'],
  maximumFilesize = 5,
  PaperComponent
}: Props) => {
  useRegisterFormField(name)

  // Since field level validation is not possible with a Yup schema we have to validate it our selfs...
  const validator = (files: File[]) => {
    try {
      createFileUploaderValidation(multiple, accept, maximumFilesize).validateSync(files)
    } catch (error) {
      if (Yup.ValidationError.isError(error)) return error.message
    }
    return null
  }

  return (
    <Field name={name} validate={validator}>
      {({ field, meta, form }: FieldProps<File[]>) => (
        <FileUploader
          multiple={multiple}
          accept={accept}
          maximumFilesize={maximumFilesize}
          files={field.value}
          error={meta.error || null}
          setFiles={files => form.setFieldValue(name, files)}
          setError={() => form.handleReset()}
          PaperComponent={PaperComponent}
        />
      )}
    </Field>
  )
}
